import { render, staticRenderFns } from "./ExpiredReservations.vue?vue&type=template&id=6eede6ad&"
import script from "./ExpiredReservations.vue?vue&type=script&lang=js&"
export * from "./ExpiredReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports